import {handleActions} from 'redux-actions'
import * as type from "../../whatsapp-messages/state/type";

export const initialState = {
    whatsappMessageList: [],
    fetching: false
}

export default handleActions({
    [type.FIND_WHATSAPP_DELIVERED_MESSAGE_LIST_SUCCESS]: (state, action) => {
        const {whatsappMessageList} = action.payload
        return {
            ...state,
            whatsappMessageList,
            fetching: false
        }
    },
}, initialState)



// WEBPACK FOOTER //
// ./src/modules/whatsapp-messages/state/reducer.js